"use client";
import Link from "next/link";
import MessageIcon from "@/components/icons/message";

const CommentButton = ({
  count,
  slug,
  isCard,
}: {
  count: number;
  slug: string;
  isCard?: boolean;
}) => {
  const handleScrollToComments = () => {
    document.getElementById("comments")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <span className="inline-flex items-center justify-center">
      {isCard ? (
        <Link className="group" href={`/${slug}`}>
          <MessageIcon className="stroke-neutral-400 size-6 stroke-[1.5] group-hover:stroke-brand-blue-500" />
        </Link>
      ) : (
        <button className="group" onClick={handleScrollToComments} type="button">
          <MessageIcon className="stroke-neutral-400 size-6 stroke-[1.5] group-hover:stroke-brand-blue-500" />
        </button>
      )}
      {count}
    </span>
  );
};

export { CommentButton };
